import React from 'react';
import { List } from 'antd';
import './index.scss';

export default (args) => {
  const renderItem = (item) => <List.Item>{item}</List.Item>;
  return <List {...args} renderItem={renderItem} />;
};
